const customer = 'SPASOLUTION';
let currentProduct;
let iframeSrc;

// Check for stacked grid layout - applies to both desktop and mobile when using new layout
const isStackedLayout = document.querySelector('.product-gallery--stacked');
const isDesktop = window.innerWidth >= 1000;

const carousel = document.querySelector('.flickity-slider');
const gridContainer = document.querySelector('.product-gallery__grid');
const mobileSlider = document.querySelector('.product-gallery__mobile-slider');
const thumbnailGallery = document.querySelector('.product-gallery__thumbnail-list');


const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50; // Check every 50ms
    const checkInterval = setInterval(() => {
        if (typeof mazingProjectAvailable === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const slugify = (str) => {
    return str
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\([^)]*\)/g, '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-');
};

const buildSKU = () => {
    const url = window.location.href;
    const match = url.match(/\/products\/([^?]+)/);
    let handle = match ? match[1] : null;
    if (!handle) return null;

    handle = handle
        .replace(/\/$/, '')
        .replace(/\([^)]*\)/g, '')
        .trim()
        .toLowerCase();

    const parts = [];

    const variantSelects = document.querySelectorAll('.product-form__variants .product-form__single-selector');
    if (variantSelects.length) {
        variantSelects.forEach(select => {
            const value = select.value || select.options[select.selectedIndex]?.text || '';
            if (value) parts.push(slugify(value));
        });
    } else {
        const selectedSpans = Array.from(
            document.querySelectorAll('.product-form__option .product-form__selected-value')
        );
        selectedSpans.forEach(el => {
            const value = el.textContent || el.innerText || '';
            if (value) parts.push(slugify(value));
        });
    }

    const sku = [handle, ...parts].filter(Boolean).join('-');
    console.log('New Mazing SKU:', sku);
    return sku;
};



const initializeScript = async () => {
    await waitForMazingFunction;

    console.log('MAZING is ready ...');

    /* AB SECTION START */

    // const waitForElement = (selector, timeout = 55000) => {
    //     return new Promise((resolve) => {
    //         const interval = 50;
    //         let elapsedTime = 0;
    //         const checkInterval = setInterval(() => {
    //             const element = document.querySelector(selector);
    //             if (element) {
    //                 clearInterval(checkInterval);
    //                 resolve(element);
    //             } else if ((elapsedTime += interval) >= timeout) {
    //                 clearInterval(checkInterval);
    //                 resolve();
    //             }
    //         }, interval);
    //     });
    // };

    // const addToCartSelector = 'button[data-action="add-to-cart"]';

    // await waitForElement(addToCartSelector);

    // mazingSetAB({
    //     enabled: true,
    //     addToCartListeners: (callback) => {
    //         document.querySelector(addToCartSelector).addEventListener('click', () => {
    //             console.log('MAZING: addToCartClicked A/B');
    //             callback();
    //         });
    //     }
    // });

    /* AB SECTION END */

    iframeSrc = await mazingProjectAvailable({
        customerName: customer,
        getSKU: buildSKU
    });


    if (!iframeSrc) {
        console.log('iframeSrc not found, aborting script execution.');
        return;
    }

    // Create hidden iframe container for 3D viewer modal
    const iframeDiv = document.createElement('div');
    iframeDiv.id = 'mazing-div';

    const iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.style.border = 'none';

    iframeDiv.appendChild(iframe);

    // Handle stacked layout (new design) - show buttons on images instead of 3D viewer in grid/slider
    if (isStackedLayout) {
        // Create 3D viewer modal overlay (hidden by default)
        const modalOverlay = document.createElement('div');
        modalOverlay.id = 'mazing-modal';
        modalOverlay.className = 'mazing-modal';
        modalOverlay.innerHTML = `
            <div class="mazing-modal__backdrop"></div>
            <div class="mazing-modal__content">
                <button class="mazing-modal__close" aria-label="Close">&times;</button>
                <div class="mazing-modal__iframe-container"></div>
            </div>
        `;
        document.body.appendChild(modalOverlay);

        // Move iframe into modal
        modalOverlay.querySelector('.mazing-modal__iframe-container').appendChild(iframeDiv);
        iframeDiv.style.width = '100%';
        iframeDiv.style.height = '100%';

        // Add modal styles
        const modalStyles = document.createElement('style');
        modalStyles.textContent = `
            .mazing-modal {
                display: none;
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 9999;
            }
            .mazing-modal.is-open {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .mazing-modal__backdrop {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.8);
            }
            .mazing-modal__content {
                position: relative;
                width: 90%;
                max-width: 1200px;
                height: 80vh;
                background: #fff;
                border-radius: 8px;
                overflow: hidden;
            }
            .mazing-modal__close {
                position: absolute;
                top: 10px;
                right: 15px;
                z-index: 10;
                background: rgba(255,255,255,0.9);
                border: none;
                font-size: 28px;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 1;
            }
            .mazing-modal__close:hover {
                background: #fff;
            }
            .mazing-modal__iframe-container {
                width: 100%;
                height: 100%;
            }
            .mazing-modal__iframe-container #mazing-div {
                width: 100%;
                height: 100%;
            }
        `;
        document.head.appendChild(modalStyles);

        // Close modal handlers
        modalOverlay.querySelector('.mazing-modal__backdrop').addEventListener('click', () => {
            modalOverlay.classList.remove('is-open');
        });
        modalOverlay.querySelector('.mazing-modal__close').addEventListener('click', () => {
            modalOverlay.classList.remove('is-open');
        });

        // Get language for button text (shared by desktop and mobile)
        const lang = (navigator.language || navigator.userLanguage || 'en').split('-')[0];
        const translations = {
            view3d: { en: 'View in 3D', de: 'In 3D ansehen', fr: 'Voir en 3D', es: 'Ver en 3D' },
            viewAR: { en: 'See in Your Space', de: 'Im Raum ansehen', fr: 'Voir chez vous', es: 'Ver en tu espacio' }
        };

        // Create buttons on first image (desktop grid)
        if (isDesktop && gridContainer) {
            const firstItem = gridContainer.querySelector('.product-gallery__grid-item--full');
            if (firstItem) {
                const buttonsContainer = document.createElement('div');
                buttonsContainer.className = 'product-gallery__3d-buttons';
                buttonsContainer.id = 'mazing-buttons';

                // View in 3D button
                const view3dBtn = document.createElement('button');
                view3dBtn.className = 'product-gallery__3d-btn';
                view3dBtn.id = 'mazing-view3d-btn';
                view3dBtn.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                        <path d="M2 17l10 5 10-5"/>
                        <path d="M2 12l10 5 10-5"/>
                    </svg>
                    <span>${translations.view3d[lang] || translations.view3d.en}</span>
                `;
                view3dBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    modalOverlay.classList.add('is-open');
                });

                // See in Your Space button (AR)
                const viewARBtn = document.createElement('button');
                viewARBtn.className = 'product-gallery__3d-btn';
                viewARBtn.id = 'mazing-viewar-btn';
                viewARBtn.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                        <line x1="8" y1="21" x2="16" y2="21"/>
                        <line x1="12" y1="17" x2="12" y2="21"/>
                    </svg>
                    <span>${translations.viewAR[lang] || translations.viewAR.en}</span>
                `;
                viewARBtn.addEventListener('click', async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof mazingLaunchAR === 'function') {
                        await mazingLaunchAR(buildSKU(), customer);
                    } else {
                        modalOverlay.classList.add('is-open');
                    }
                });

                buttonsContainer.appendChild(view3dBtn);
                buttonsContainer.appendChild(viewARBtn);
                firstItem.appendChild(buttonsContainer);
            }
        }

        // Create buttons for mobile slider
        if (!isDesktop && mobileSlider) {
            const firstSlide = mobileSlider.querySelector('.product-gallery__slide');
            if (firstSlide) {
                const mobileButtonsContainer = document.createElement('div');
                mobileButtonsContainer.className = 'product-gallery__3d-buttons';
                mobileButtonsContainer.id = 'mazing-buttons-mobile';

                // Mobile View in 3D button
                const mobileView3dBtn = document.createElement('button');
                mobileView3dBtn.className = 'product-gallery__3d-btn';
                mobileView3dBtn.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                        <path d="M2 17l10 5 10-5"/>
                        <path d="M2 12l10 5 10-5"/>
                    </svg>
                    <span>${translations.view3d[lang] || translations.view3d.en}</span>
                `;
                mobileView3dBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    modalOverlay.classList.add('is-open');
                });

                // Mobile See in Your Space button (AR)
                const mobileViewARBtn = document.createElement('button');
                mobileViewARBtn.className = 'product-gallery__3d-btn';
                mobileViewARBtn.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                        <line x1="8" y1="21" x2="16" y2="21"/>
                        <line x1="12" y1="17" x2="12" y2="21"/>
                    </svg>
                    <span>${translations.viewAR[lang] || translations.viewAR.en}</span>
                `;
                mobileViewARBtn.addEventListener('click', async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof mazingLaunchAR === 'function') {
                        await mazingLaunchAR(buildSKU(), customer);
                    } else {
                        modalOverlay.classList.add('is-open');
                    }
                });

                mobileButtonsContainer.appendChild(mobileView3dBtn);
                mobileButtonsContainer.appendChild(mobileViewARBtn);
                firstSlide.appendChild(mobileButtonsContainer);
            }
        }
    } else if (carousel) {
        // Carousel layout (legacy only, not stacked mobile) - inject into carousel
        iframeDiv.className = 'product-gallery__carousel-item';
        iframeDiv.style.height = '480px';
        iframeDiv.style.width = '100%';
        iframeDiv.style.position = 'absolute';
        iframeDiv.style.left = '-50%';
        iframeDiv.style.opacity = '1';

        carousel.insertBefore(iframeDiv, carousel.firstChild.nextSibling);

        // Thumbnail for legacy carousel mode
        const thumbnailElement = document.createElement('a');
        thumbnailElement.className = 'product-gallery__thumbnail';
        thumbnailElement.style.height= '70px';
        thumbnailElement.id= 'mazing-thumb';

        const thumbnailDiv = document.createElement('div');
        thumbnailDiv.className = 'aspect-ratio';
        thumbnailDiv.style.height = '100%';

        const svgImgIcon = document.createElement('img');
        svgImgIcon.className = 'image--fade-in lazyloaded';
        svgImgIcon.setAttribute('data-src', 'https://cdn.mazing.link/assets/svg/3D.svg');
        svgImgIcon.setAttribute('alt', 'Mazing Viewer');
        svgImgIcon.src = 'https://cdn.mazing.link/assets/svg/3D.svg';
        svgImgIcon.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';
        svgImgIcon.style.padding = '15%';

        thumbnailDiv.appendChild(svgImgIcon);
        thumbnailElement.appendChild(thumbnailDiv);

        if (thumbnailGallery) {
            thumbnailGallery.insertBefore(thumbnailElement, thumbnailGallery.firstChild.nextSibling);
        }

        // Legacy carousel thumbnail functionality (only for non-grid layout)
        const ensureZoomNoticeVisibility = () => {
            const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
            const isIframeSelected = thumbnailElement.classList.contains('is-nav-selected');

            if (zoomNotice) {
                zoomNotice.style.display = isIframeSelected ? 'none' : '';
            }
        };

        const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');
        const flickityViewport = document.querySelector('.flickity-viewport');

        allThumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
                allThumbnails.forEach(thumb => thumb.classList.remove('is-nav-selected'));

                thumbnail.classList.add('is-nav-selected');

                const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
                allCarouselItems.forEach(item => {
                    item.classList.add('item--hidden');
                    item.classList.remove('is-selected')
                    item.setAttribute('aria-hidden', 'true');
                });

                const selectedCarouselItem = allCarouselItems[index];
                if (selectedCarouselItem) {
                    selectedCarouselItem.classList.remove('item--hidden');
                    selectedCarouselItem.classList.add('is-selected');
                    selectedCarouselItem.removeAttribute('aria-hidden');
                }

                if (thumbnail === thumbnailElement) {
                    flickityViewport.style.height = '480px';
                } else {
                    flickityViewport.style.height = '';
                }

                ensureZoomNoticeVisibility();
            });
        });

        ensureZoomNoticeVisibility();
    }

    const productVariants = document.querySelector('.product-form__variants');
    let colorsContainer;
    let colors;
    let colorSelect;

    if (productVariants) {
        colorsContainer = productVariants.querySelector('.color-swatch-list');
        if (colorsContainer) {
            colors = colorsContainer.querySelectorAll('.color-swatch');
        } else {
            colorSelect = productVariants.querySelector('.product-form__single-selector');
        }
    }

    async function handleColorChange(colorValue) {
        console.log('COLOR VALUE:', colorValue);
        if (!colorValue) return;

        let cleanColor = colorValue.replace('#', '').replace(/\s+/g, '').toLowerCase();

        const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
        const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');

        const mazingThumb = document.getElementById('mazing-thumb');
        const mazingDiv = document.getElementById('mazing-div');

        if (mazingThumb) mazingThumb.classList.remove('is-nav-selected');
        if (mazingDiv) {
            mazingDiv.classList.add('item--hidden');
            mazingDiv.classList.remove('is-selected');
            mazingDiv.setAttribute('aria-hidden', 'true');
        }

        for (let i = 0; i < allThumbnails.length; i++) {
            const thumb = allThumbnails[i];
            const item = allCarouselItems[i];

            if (thumb !== mazingThumb) {
                thumb.classList.add('is-nav-selected');
                item.classList.remove('item--hidden');
                item.classList.add('is-selected');
                item.removeAttribute('aria-hidden');
                break;
            }
        }

        const flickityViewport = document.querySelector('.flickity-viewport');
        if (flickityViewport) flickityViewport.style.height = '';

        const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
        if (zoomNotice) zoomNotice.style.display = '';

        // set new iframeSrc
        const newIframeSrc = await mazingProjectAvailable({
            customerName: customer,
            getSKU: buildSKU
        });

        if (newIframeSrc) {
            iframeSrc = newIframeSrc;
            const iframe = document.querySelector('#mazing-div iframe');
            if (iframe) {
                iframe.src = newIframeSrc;
            }

            await mazingRefreshSKU(buildSKU(), customer);
        } else {
            console.log('No Mazing Project found! Return;');
        }
    }

    if (colors) {
        // CASE 1: Farb-Swatches
        colors.forEach(div => {
            const label = div.querySelector('.color-swatch__item');

            label.addEventListener('click', () => {
                const colorValue = label.getAttribute('title');
                handleColorChange(colorValue);
            });
        });
    } else if (colorSelect) {
        // CASE 2: Dropdown-Auswahl
        colorSelect.addEventListener('change', (event) => {
            const selectedOption = event.target.options[event.target.selectedIndex];
            const colorValue = selectedOption.value;
            handleColorChange(colorValue);
        });
    }



    // --- HANDLE SIZE DROPDOWN SELECTION ---
    const sizeSelect = productVariants.querySelector('select.product-form__single-selector');

    if (sizeSelect) {
        sizeSelect.addEventListener('change', async () => {
            const selectedSize = sizeSelect.value.trim();
            const cleanSize = selectedSize.replace(/\s/g, '').toLowerCase();
            console.log('SELECTED SIZE:', selectedSize);

            const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
            const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');

            const mazingThumb = document.getElementById('mazing-thumb');
            const mazingDiv = document.getElementById('mazing-div');

            if (mazingThumb) mazingThumb.classList.remove('is-nav-selected');
            if (mazingDiv) {
                mazingDiv.classList.add('item--hidden');
                mazingDiv.classList.remove('is-selected');
                mazingDiv.setAttribute('aria-hidden', 'true');
            }

            for (let i = 0; i < allThumbnails.length; i++) {
                const thumb = allThumbnails[i];
                const item = allCarouselItems[i];

                if (thumb !== mazingThumb) {
                    thumb.classList.add('is-nav-selected');
                    item.classList.remove('item--hidden');
                    item.classList.add('is-selected');
                    item.removeAttribute('aria-hidden');
                    break;
                }
            }

            const flickityViewport = document.querySelector('.flickity-viewport');
            if (flickityViewport) flickityViewport.style.height = '';

            const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
            if (zoomNotice) zoomNotice.style.display = '';

            // set new iframeSrc
            const newIframeSrc = await mazingProjectAvailable({
                customerName: customer,
                getSKU: buildSKU

            });

            if (newIframeSrc) {
                iframeSrc = newIframeSrc;
                const iframe = document.querySelector('#mazing-div iframe');
                if (iframe) {
                    iframe.src = newIframeSrc;
                }

                await mazingRefreshSKU(buildSKU(), customer);
            } else {
                console.log('No Mazing Project found for this size. Return;')
            }
        });
    }




    document.addEventListener('change', async (e) => {
        if (!e.target.closest('.product-form__variants')) return;
        if (!e.target.classList.contains('product-form__single-selector')) return;

        const newIframeSrc = await mazingProjectAvailable({
            customerName: customer,
            getSKU: buildSKU
        });

        if (newIframeSrc) {
            const iframe = document.querySelector('#mazing-div iframe');
            if (iframe) iframe.src = newIframeSrc;

            //try { mazingRefreshSKU && await mazingRefreshSKU(buildSKU(), customer); } catch(e){}
        }
    });

};

const initButton = async () => {
    await waitForMazingFunction;

    await mazing({
        customerName: customer,
        buttonConfiguration: {
            customStyle: `
                .product-form__option {
                    position: relative;
                }
                
                .product-form__option .select-wrapper--primary {
                    display: inline-block;
                }
                
                .mazing-button-container {
                    position: absolute !important;
                    top: 0;
                    left: 170px;
                    height: 100%;
                    display: flex;
                    align-items: end;
                
                    button {
                        padding-left: 24px;
                        padding-right: 24px;
                        border-radius: 0px;
                    }
                }
                
                .mazing-threed-btn-text{
                    color: #1E2D7D;
                }
                
                .mazing-ar-btn-text{
                    color: #1E2D7D;
                }
                
                .mazing-threed-btn-icon {
                    filter: brightness(0) saturate(100%) invert(15%) sepia(57%) saturate(2222%) hue-rotate(215deg) brightness(102%) contrast(99%);
                } 
                
                .mazing-ar-btn-icon {
                    filter: brightness(0) saturate(100%) invert(15%) sepia(57%) saturate(2222%) hue-rotate(215deg) brightness(102%) contrast(99%);
                }

                @media (max-width: 768px) {
                   
                   .mazing-threed-btn,
                   .mazing-ar-btn { 
                      padding-left: 12px !important;
                      padding-right: 20px !important;

                      span {
                          line-height: normal;
                      }
                   }
                }
            `,
            placementSelector: '.product-form__option',
            threedBtn: {
                enabled: true,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in 3D",
                        "de": "In 3D ansehen",
                        "fr": "Voir en 3D",
                        "es": "Ver en 3D"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            },
            arBtn: {
                enabled: false,
                icon: false,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in Room",
                        "de": "Im Raum anzeigen",
                        "fr": "Voir dans votre espace",
                        "es": "Ver en tu espacio"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: buildSKU
    });

    const checkAndBindButton = () => {
        const button = document.getElementById('mazing-threed-btn');
        if (button && !button.dataset.bound) {
            button.dataset.bound = "true";
            button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('Mazing 3D Button clicked (submit unterdrückt)');
            });
        } else {
            setTimeout(checkAndBindButton, 100);
        }
    };

    checkAndBindButton();

    console.log('Mazing initialized.');
};

//initButton();
initializeScript();
